import { CHANGE_IS_MOBILE } from './constants';

export function changeIsMobile(isMobile) {
  return {
    type: CHANGE_IS_MOBILE,
    payload: isMobile,
  };
}
